// extracted by mini-css-extract-plugin
export default {"thoughtProcess":"analysis-panel_thoughtProcess__D6sLX","closeBtn":"analysis-panel_closeBtn__-KRt9","pdfZone":"analysis-panel_pdfZone__SESYc"};